import { createDrift, } from "@delvtech/drift";
import { uniswapV3InitializerAbi } from "../../abis";
export class ReadUniswapV3Initializer {
    constructor(address, drift = createDrift()) {
        this.initializer = drift.contract({
            abi: uniswapV3InitializerAbi,
            address,
        });
    }
    async getState(pool) {
        return this.initializer.read("getState", { pool });
    }
}
//# sourceMappingURL=ReadInitializer.js.map